export default __webpack_public_path__ + "static/mmm-4056263146e776a8c45ac1ce4d825c41.png";